/*=============================
=       Lazy Load Images      =
=============================*/

document.addEventListener('DOMContentLoaded', function() {
	var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container, #hero video')),
		lazyImages = [].slice.call(document.querySelectorAll('main img:not(.not-lazy):not(.first), main .bg-container:not(.not-lazy):not(.first), section.statistics video, footer img')),
		active = false,
		heroLazyLoad = function() {
			heroImages.forEach(function(img) {
				imgLazyLoad(img, 300);

				heroImages = heroImages.filter(function(image) {
					return image !== img;
				});

				if(heroImages.length === 0) {
					document.removeEventListener('scroll', heroLazyLoad);
					window.removeEventListener('resize', heroLazyLoad);
					window.removeEventListener('orientationchange', heroLazyLoad);
				}
			});
		};

	// Hero Images
	setTimeout(heroLazyLoad, 1);

	// Regular Images
	var lazyLoad = function() {
		if(active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(img) {
					if((img.getBoundingClientRect().top <= (window.innerHeight + 300) && img.getBoundingClientRect().bottom >= 0) && getComputedStyle(img).display !== 'none') {
						imgLazyLoad(img, (img.classList.contains('bg-container') ? 300 : 0));

						lazyImages = lazyImages.filter(function(image) {
							return image !== img;
						});

						if(lazyImages.length === 0) {
							document.removeEventListener('scroll', lazyLoad);
							window.removeEventListener('resize', lazyLoad);
							window.removeEventListener('orientationchange', lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener('scroll', lazyLoad);
	window.addEventListener('resize', heroLazyLoad);
	window.addEventListener('resize', lazyLoad);
	window.addEventListener('orientationchange', heroLazyLoad);
	window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyLoad(img, delay) {
	var url = img.getAttribute('data-src'+(checkWidth(768) && img.hasAttribute('data-src-mobile') ? '-mobile' : ''));

	if(img.tagName == 'IMG' || img.tagName == 'VIDEO')
		img.src = url;
	else
		img.style.backgroundImage = 'url('+url+')';

	setTimeout(function() {
		img.classList.add('loaded');
	}, (img.tagName == 'VIDEO' ? 0 : delay));
}

/*=============================
=          Site Toggle        =
=============================*/

var siteToggle = [].slice.call(document.querySelectorAll('#site-toggle a, #sidebar a, #toggle-cards a, .toggle-cards a')),
	domain = window.location.hostname;

siteToggle.forEach(function(toggle) {
	toggle.addEventListener('click', function(e) {
		if(this.dataset.home == 'doctors')
			Cookie.set('homepage', 'doctors', { expires: 30, domain: domain });
		else if(this.dataset.home == 'patients')
			Cookie.remove('homepage', { domain: domain });
	});
});

/*=============================
=         Sticky Header       =
=============================*/

var stickyHeader = new Waypoint({
	element: hero.querySelector('.container2'),
	handler: function(direction) {
		var down = direction == 'down';

		if(down)
			body.classList.add('sticky');
		else
			body.classList.remove('sticky');
	},
	offset: header.offsetHeight
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});

/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
	mobileMenuButton = document.getElementById('mobile-menu-button'),
	locationsCTA = document.querySelector('#cta-links button.locations + .submenu');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(document.querySelectorAll('#cta-links button:not(.lang-button), #nav-wrap button:not(.lang-button):not(#search-button)')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var parent = this.parentNode.parentNode,
		openSibling = parent.querySelector('.open'),
		isOpen = this.classList.contains('open'),
		isMobileMenuButton = this == mobileMenuButton,
		animation = checkWidth(1200) ? (isOpen ? 'slideUp' : 'slideDown') : (isOpen ? 'fadeOut' : 'fadeIn'),
		display = !isOpen ? (isMobileMenuButton ? 'flex' : 'block') : 'none',
		submenu = this.nextElementSibling;

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	Velocity(submenu, animation, {duration: isMobileMenuButton ? 300 : 150, display});

	this.classList.toggle('open');

	submenu.setAttribute('aria-expanded', (submenu.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(header.querySelector('.open'));
}

function closeMenu(el) {
	if(el && !el.classList.contains('language-picker-container')) {
		var submenu = el.nextElementSibling;

		Velocity(submenu, checkWidth(1200) ? 'slideUp' : 'fadeOut', {duration: el == mobileMenuButton ? 300 : 150});

		el.classList.remove('open');

		submenu.setAttribute('aria-expanded', 'false');

		closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	var openButton = header.querySelector('.open:not(#mobile-menu-button)');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}

function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
}

/*=============================
=        Scroll To Link       =
=============================*/

var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			var answer = section.querySelector('.answer');

			Velocity(answer, 'slideDown', {duration: 250});

			section.querySelector('button').classList.add('open');

			answer.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}

/*=============================
=         Element Link        =
=============================*/

var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
			var href = this.dataset.href;

			if(href.indexOf(location.host) == -1)
				window.open(href);
			else
				window.location.href = href;
		}
	});
});

/*=============================
=        Announcements        =
=============================*/

if(announcementsContainer) {
	var announcementButtons = [].slice.call(announcementsContainer.querySelectorAll('.controller button')),
		firstAnnouncement = announcementsContainer.querySelector('li:first-child'),
		lastAnnouncement = announcementsContainer.querySelector('li:last-child'),
		autoSlide = function() {
			slideAnnouncement();
		};

	if(announcementButtons.length)
		var intervalID = setInterval(autoSlide, 15000);

	announcementButtons.forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(intervalID);

			if(this.classList.contains('next')) {
				slideAnnouncement();

				if(this.previousSibling.classList.contains('pause'))
					intervalID = setInterval(autoSlide, 15000);
			}
			else {
				var isPlay = this.classList.contains('play');

				if(isPlay)
					intervalID = setInterval(autoSlide, 15000);

				this.className = isPlay ? 'pause' : 'play';
				this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Announcements');
			}
		});
	});

	announcementsContainer.querySelector('.close').addEventListener('click', function() {
		announcementsContainer.classList.toggle('closed');

		var isClosed = announcementsContainer.classList.contains('closed');

		if(isClosed)
			Cookie.set('announcements', 'closed', {domain: domain});
		else
			Cookie.remove('announcements', {domain: domain});

		this.setAttribute('aria-label', (isClosed ? 'Open' : 'Close') + ' Announcements');
	});
}

function slideAnnouncement() {
	var current = document.querySelector('#announcements .current'),
		sibling = current == lastAnnouncement ? firstAnnouncement : current.nextSibling;

	current.classList.add('hide');

	setTimeout(function() {
		current.className = '';
		sibling.classList.add('current', 'next');
	}, 550);
}

/*=============================
=          Accordion          =
=============================*/

var accordions = [].slice.call(document.querySelectorAll('.accordion button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		answer.setAttribute('aria-expanded', (answer.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		// setTimeout(function() {
		// 	scrollToElement(this.parentNode);
		// }, 250);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		var answer = openAccordion.nextElementSibling;

		Velocity(answer, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');

		answer.setAttribute('aria-expanded', 'false');
	}
}

/*=============================
=       Google Translate      =
=============================*/

var languageSwitchers = [].slice.call(document.querySelectorAll('.lang-button'));

languageSwitchers.forEach(function(switcher) {
	switcher.addEventListener('click', function(e) {
		var parent = this.parentNode,
			list = parent.querySelector('ul');

		closeDropDown(parent, e);

		parent.classList.toggle('open');

		list.setAttribute('aria-expanded', (list.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'slideUp' : 'slideDown'), {duration: 150});
	});
});

body.addEventListener('click', function(e) {
	closeDropDown(this, e);
});

function closeDropDown(el, e) {
	var open = document.querySelector('.language-picker-container.open');

	if(open && open !== el && !open.contains(e.target)) {
		var list = open.querySelector('ul');

		open.classList.remove('open');
		list.setAttribute('aria-expanded', 'false');
		Velocity(list, 'slideUp', {duration: 150});
	}
}

var languages = [].slice.call(document.querySelectorAll('.language-picker-container a[href="#"], .language-switcher-button'));

languages.forEach(function(language) {
	language.addEventListener('click', function(e) {
		e.preventDefault();

		var lang = this.getAttribute('hreflang');

		if(Cookie.get('language') !== lang) {
			googTransHandle(false, lang);

			var splitDomain = location.host.split('.');

			if(splitDomain.length >= 2)
				googTransHandle(location.host.replace(splitDomain[0]+(splitDomain.length == 2 ? splitDomain[1] : ''), ''), lang);

			window.location.reload();
		}
	});
});

function googTransHandle(domain, lang) {
	if(!domain) {
		if(typeof Cookie.get('googtrans')!=='undefined') {
			Cookie.remove('language');
			Cookie.remove('googtrans');
		}
		if(lang!=='en') {
			Cookie.set('language', lang);
			Cookie.set('googtrans', '/en/'+lang);
		}
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined') {
			Cookie.remove('language', {domain: domain});
			Cookie.remove('googtrans', {domain: domain});
		}
		if(lang!=='en') {
			Cookie.set('language', lang, {domain: domain});
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
		}
	}
}

/*=============================
=             Modal           =
=============================*/

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]:not(.gm-style-iw):not(#popunder):not(.ot-sdk-container):not(:has(.ot-pc-header))')),
	ieModal = document.getElementById('ie-modal');

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('.close-modal') || (modal != searchModal && !modal.querySelector('.content').contains(e.target)))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		// if(modal == videoModal) {
		// 	setTimeout(function() {
		// 		videoIframe.src = 'about:blank';
		// 		skipLinkToggleDisplay(false);
		// 		setFocus(false, false);
		// 	}, 300);
		// }
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});

if(ieModal) {
	ieModal.querySelector('.close-modal').focus();
	skipLinkToggleDisplay(true);
	setFocus(true, false);
}

/*=============================
=            Search           =
=============================*/

var searchButton = document.getElementById('search-button'),
	searchModal = document.getElementById('search-modal');

if(searchButton && searchModal) {
	searchButton.addEventListener('click', function() {
		Velocity(searchModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

		setTimeout(function() {
			searchModal.setAttribute('aria-hidden', 'false');
			searchModal.querySelector('input').focus();
		}, 300);
	});
}

[].slice.call(document.querySelectorAll('form.search')).forEach(function(form) {
	form.addEventListener('submit', function(e) {
		e.preventDefault();

		var searchInput = this.querySelector('input');

		if(searchInput.value === '')
			searchInput.classList.add('error');
		else
			this.submit();
	});
});

/*=============================
=             Video           =
=============================*/

[].slice.call(document.querySelectorAll('.video-container button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var parent = this.parentNode.parentNode,
			thumbnail = parent.querySelector('.thumbnail'),
			video = parent.querySelector('figure.video > *:first-child');

		if(thumbnail)
			Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

		playVideo(video);
	});
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;

	video.src = src.replace('?autoplay=1&rel=0', '');
}

/*=============================
=     Google Map Waypoint     =
=============================*/

var locationMaps = [].slice.call(document.querySelectorAll('.map-container'));

if(locationMaps.length) {
	window.initMap = function() {
		locationMaps.forEach(function(mapElement) {
			initMap(mapElement);
		});
	};

	scriptWaypoint(locationMaps[0], 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD8_98HqTwj-ZtJAsN1b2HoDe25CWiGOLU&callback=initMap&libraries=geometry', '150%');
}

function initMap(mapElement) {
	var openWindow,
		currentMarker,
		pin = '/assets/images/icons/map-pin.svg',
		currentPin = '/assets/images/icons/map-pin-current.svg';

	axios.get('/map-section/'+mapElement.getAttribute('data-location')).then(function(r) {
		var locations = r.data.locations,
			center = JSON.parse('['+r.data.center+']'),
			mapOptions = {
				zoom: r.data.zoom,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				center: new google.maps.LatLng(center[0]-.8, center[1]+1.2),
				styles: mapStyles
			};

		map = new google.maps.Map(mapElement, mapOptions);

		locations.forEach(function(location) {
			var isLocationPage = location.openWindow,
				coordinates = JSON.parse('['+location.coordinates+']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html
				}),
				marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					animation: google.maps.Animation.DROP,
					icon: pin
				});

			if(!openWindow && !checkWidth(768)) {
				infowindow.open(map, marker); // Remove this to close infowindow by default
				openWindow = infowindow;

				marker.setIcon(currentPin);
				currentMarker = marker;
			}

			infowindow.addListener('closeclick', function() {
				openWindow = false;
				currentMarker.setIcon(pin);
			});

			marker.addListener('click', function() {
				if(currentMarker)
					currentMarker.setIcon(pin);

				if(openWindow)
					openWindow.close();

				if(currentMarker != marker) {
					marker.setIcon(currentPin);
					currentMarker = marker;

					infowindow.open(map, marker);
					openWindow = infowindow;
				}
				else {
					openWindow = false;
					currentMarker = false;
				}
			});
		});
	});
}

/*=============================
=           Popunder          =
=============================*/

var popunder = document.getElementById('popunder');

if(popunder && !popunder.classList.contains('minimize'))
	popunder.querySelector('button').focus();

[].slice.call(document.querySelectorAll('#popunder, #popunder button, #popunder a')).forEach(function(button) {
	button.addEventListener('click', function(e) {
		if(this.tagName == 'BUTTON' || this.tagName == 'A' || !document.querySelector('#popunder > div').contains(e.target)) {
			if(popunder.classList.contains('minimize')) {
				popunder.classList.remove('minimize');
				Cookie.remove('popunder', {domain: domain});
			}
			else {
				popunder.classList.add('minimize');
				Cookie.set('popunder', 'minimize', {expires: 3, domain: domain});
			}
		}
	});
});

/*=============================
=       Footer Accordion      =
=============================*/

var footerAccordion = [].slice.call(footer.querySelectorAll('#footer-two button'));

footerAccordion.forEach(function(location) {
	location.addEventListener('click', function() {
		var details = this.nextSibling;

		this.classList.toggle('open');

		Velocity(details, window.getComputedStyle(details).display == 'block' ? 'slideUp' : 'slideDown', {duration: 250});

		details.setAttribute('aria-expanded', (details.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));
	});
});

/*=============================
=       Skip to Content       =
=============================*/

[].slice.call(document.querySelectorAll('.skip-link')).forEach(function(skipLink) {
	skipLink.addEventListener('click', function(e) {
		e.preventDefault();

		var selectors = {
				'#menu': '#menu > li > *:first-child',
				'#main': '#hero a, main a',
				'#footer': '#footer a'
			},
			firstLink = document.querySelector(selectors[this.getAttribute('href')]);

		if(firstLink) {
			scrollToElement(firstLink);
			firstLink.focus();
		}
	});
});

window.skipLinkToggleDisplay = function skipLinkToggleDisplay(hide) {
	[].slice.call(document.querySelectorAll('.skip-link')).forEach(function(skipLink) {
			skipLink.style.display = hide ? 'none' : '';
	});
};

/*=============================
=        Keyboard Focus       =
=============================*/

document.addEventListener('keydown', function(e) {
	if(e.keyCode == 9 && !body.classList.contains('tabbing'))
		body.classList.add('tabbing');
});

document.addEventListener('mousedown', function() {
	if(body.classList.contains('tabbing'))
		body.classList.remove('tabbing');
});

/*=============================
=           Finder          =
=============================*/

var finder = document.querySelector('body#finder');

if (finder) {
  var locationsTab = document.querySelector('.tab.locations-tab'),
    physiciansTab = document.querySelector('.tab.physicians-tab')
    // locationsTabButton = document.querySelector('.tab-button.locations'),
    // physiciansTabButton = document.querySelector('.tab-button.physicians'),
    formPhysicians = document.querySelector('form.form-physicians'),
    formLocations = document.querySelector('form.form-locations')
    physicianCards = document.querySelectorAll('.physician-card'),
    heroText = document.querySelector('#hero .title'),
	mapContainer = document.querySelector('#map-container'),
    locationsAccordionDivs = document.querySelectorAll('.locations-flex .accordion > div');

  const showTabCondition = true;
  processTabs(showTabCondition);

  if (document.querySelector('.tab-button'))
    document.querySelectorAll('.tab-button').forEach(item => {
      item.addEventListener('click', setActiveTab)
    });

  function setActiveTab(e) {
    e.preventDefault();
    const tabHref = this.getAttribute('href'),
      showTabCondition = tabHref === '#location';

    processTabs(showTabCondition);
  }

  if (formPhysicians) formPhysicians.addEventListener('submit', formProcessFinder);
  if (formLocations) formLocations.addEventListener('submit', formProcessFinder);

  function formProcessFinder(e) {
    e.preventDefault();

    let url = new URL(window.location.href);
    var searchParams = url.searchParams;

    var form = this,
      locationsSelect = this.querySelector('.locations-select'),
      physiciansSelect = this.querySelector('.physicians-select'),
      regionSelect = this.querySelector('.regions-select'),
      cityInput = this.querySelector('.city-input'),
      clearSearch = this.querySelector('.clear-search');

    [cityInput, physiciansSelect, locationsSelect, regionSelect].forEach((el) => {
      // console.log("EL", el);
      if (el !== null) {
        const elValue = el.value;
        const elParam = el.classList[0].split('-')[0];

        if (elValue != 0) {
          searchParams.delete(elParam);
          searchParams.append(elParam, elValue);
        } else {
          searchParams.delete(elParam);
        }
      }
    });

    window.history.replaceState(null, null, url);

    if (form.classList[0] == 'form-locations') {
      submitLocationsForm();

      if (cityInput.value != '' || physiciansSelect.value != 0 || regionSelect.value != 0) {
        clearSearch.style.opacity = '1';
      } else {
        clearSearch.style.opacity = '0';
      }
    } else {
      submitPhysiciansForm();

      if ((locationsSelect && locationsSelect.value != 0) || (regionSelect && regionSelect.value != 0)) {
        clearSearch.style.opacity = '1';
      } else {
        clearSearch.style.opacity = '0';
      }
    }
  }

  function submitLocationsForm() {
    let url = new URL(window.location.href);
    var searchParams = url.searchParams;
	let regionLocationCount = {
		'Charleston & North Charleston': 0,
		'Bluffton, Hilton Head & Coastal GA': 0,
		'Grand Strand & Lake City': 0,
		'Orangeburg & Walterboro': 0
	};

    locationsAccordionDivs.forEach((locationAcc) => {
      var locationAccPhysicians = JSON.parse(locationAcc.getAttribute('data-physicians') || '[]') || [];
	  var locationAccRegion = locationAcc.getAttribute('data-region') || '';
      // console.log("LOCATION ACC REGION", locationAcc);

      ['physicians', 'regions'].forEach((el) => {
		  if (searchParams.has(el)) {
		    document.querySelectorAll('.' + el + '-select').forEach(function (formEl) {
		      formEl.value = searchParams.get(el);
		    });
		  }
		});

      if (searchParams.get('city')) {
        // console.log('SEARCH PARAMS CITY', searchParams.get('city'));
        document.querySelector('.city-input').value = searchParams.get('city');
      }

	  if (
	    (searchParams.get('physicians') === null || locationAccPhysicians.includes(searchParams.get('physicians'))) &&
	    (searchParams.get('regions') === null || locationAccRegion === searchParams.get('regions'))
	  ) {
	    locationAcc.classList.remove('hide');
	  } else {
	    locationAcc.classList.add('hide');
	  }

      if (!locationAcc.classList.contains('hide')) {
        regionLocationCount[locationAcc.getAttribute('data-region')]++;
      }
    });

    document.querySelectorAll('.locations-flex .accordion > h4').forEach(el => {
      // console.log("LOCATION ACCORDION", el);
      if (searchParams.get('regions') !== null) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    })

	for (const [key, value] of Object.entries(regionLocationCount)) {
	  const regionHeading = document.querySelector('.locations-flex .accordion > h4[data-region="' + key + '"]');

	  if (regionHeading) {
	    regionHeading.style.display = value === 0 ? 'none' : 'block';
	  }
	}

    if (typeof google !== 'undefined') {
      initMapFinder();
    } else {
      setTimeout(() => {
        initMapFinder();
      }, 1500);
    }

    var locationsCountCollection = document.querySelector('.locationsCount').value,
      locationsText = document.querySelector('.finder-locations-text');

    setTimeout(() => {
      if (locationsCountCollection == document.querySelectorAll('.locations-flex .accordion > div:not(.hide)').length) {
        locationsText.innerHTML = 'Showing all ' + (searchParams.get('regions') !== null ? searchParams.get('regions') : '') + ' locations';
      } else if (document.querySelectorAll('.locations-flex .accordion > div:not(.hide)').length <= 0) {
        locationsText.innerHTML = 'No locations found';
      } else {
        locationsText.innerHTML = 'Showing ' + document.querySelectorAll('.locations-flex .accordion > div:not(.hide)').length + ' ' + (searchParams.get('regions') !== null ? searchParams.get('regions') : '') + ' locations';
      }
    }, 500);
  }

  submitLocationsForm();

  function submitPhysiciansForm() {
    let url = new URL(window.location.href);
    var searchParams = url.searchParams;


	physicianCards.forEach((physicianCard) => {
	  var physicianCardLocations = physicianCard.getAttribute('data-locations') !== null
	    ? physicianCard.getAttribute('data-locations').split(',')
	    : [];

	  if (
	    searchParams.get('locations') === null ||
	    physicianCardLocations.includes(searchParams.get('locations'))
	  ) {
	    physicianCard.classList.remove('hide');
	  } else {
	    physicianCard.classList.add('hide');
	  }
	});


    var physiciansCountCollection = document.querySelector('.physiciansCount').value,
      physiciansText = document.querySelector('.finder-physician-text');

    setTimeout(() => {
      if (physiciansCountCollection == document.querySelectorAll('.physicians-cards > div .card:not(.hide)').length) {
        physiciansText.innerHTML = 'Showing all physicians';
      } else if (document.querySelectorAll('.physicians-cards > div .card:not(.hide)').length <= 0) {
        physiciansText.innerHTML = 'No physicians found';
      } else {
        physiciansText.innerHTML = 'Showing ' + document.querySelectorAll('.physicians-cards > div .card:not(.hide)').length + ' physicians';
      }
    }, 500);
  }

  submitPhysiciansForm();

  function processTabs(showTabCondition) {

    if (showTabCondition) {
      locationsTab.classList.add('active');
    //   locationsTabButton.classList.add('active');

      physiciansTab.classList.remove('active');
    //   physiciansTabButton.classList.remove('active');

      document.querySelector('.locations-select').value = 0;

      window.location.hash = '#location';
      heroText.innerHTML = 'Search Locations';

      if (typeof google !== 'undefined') {
        initMapFinder();
      } else {
        setTimeout(() => {
          initMapFinder();
        }, 1500);
      }
    } else {
      physiciansTab.classList.add('active');
    //   physiciansTabButton.classList.add('active');

      locationsTab.classList.remove('active');
    //   locationsTabButton.classList.remove('active');

      document.querySelector('.physicians-select').value = 0;
      document.querySelector('.city-input').value = '';

      window.location.hash = '#physician';
      heroText.innerHTML = 'Search Physicians';
    }
  }

  function initMapFinder() {
    let url = new URL(window.location.href);
    var searchParams = url.searchParams;

    var strCoordinates = mapContainer && mapContainer.hasAttribute('data-coordinates') ? mapContainer.getAttribute('data-coordinates') : '28.7107851,-94.4006464',
      coordinates = JSON.parse('[' + strCoordinates + ']'),
      latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
      mapOptions = {
        zoom: 15,
        streetViewControl: false, // hide the yellow Street View pegman
        scaleControl: true, // allow users to zoom the Google Map
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        disableDefaultUI: true,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_CENTER,
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
        center: latLng,
        styles: mapStyles
      },
      map = new google.maps.Map(mapContainer, mapOptions);

    var i = 0;
    var cityAddress = '';

    if (searchParams.get('city') == 'Current Location') {
      let url = new URL(window.location.href);
      const searchParams = url.searchParams;
      cityAddress = searchParams.get('pos');
    } else {
      cityAddress = searchParams.get('city') + ' South Carolina';
    }

    var bounds = new google.maps.LatLngBounds(),
      radius = parseInt(450, 10) * 1000,
      geocoder = new google.maps.Geocoder(),
      openWindow,
      gmarkers = [];

    document.querySelectorAll('.locations-flex .accordion > div:not(.hide)').forEach(function (location) {
      var coordinates = location.getAttribute('data-coords').split(','),
        latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
        infowindow = new google.maps.InfoWindow({
          position: latLng,
          content: '<h4>' + location.querySelector('button h4').innerHTML + '</h4>' + location.querySelector('.answer div .details').innerHTML
        }),
        marker = new google.maps.Marker({
          map: map,
          position: latLng,
          draggable: false,
          animation: google.maps.Animation.DROP,
          icon: '/assets/images/icons/map-pin.svg'
        });

      gmarkers.push(marker);

      marker.addListener('click', function () {
        if (openWindow)
          openWindow.close();

        if (checkWidth(768))
          mapContainer.classList.remove('info-closed');

        infowindow.open(map, marker);
        openWindow = infowindow;

        document.querySelectorAll('.locations-flex .accordion > div').forEach(function (el, key) {
          var markerCoords = marker.getPosition().lat() + ',' + marker.getPosition().lng();
          if (el.getAttribute('data-coords') == markerCoords) {
            if (!document.querySelector('.locations-flex .accordion > div[data-coords="' + markerCoords + '"] button').classList.contains('open')) {
              document.querySelector('.locations-flex .accordion > div[data-coords="' + markerCoords + '"] button').click();
            }
          }
        });
      });

      infowindow.addListener('closeclick', function () {
        mapContainer.classList.add('info-closed');
      });

      bounds.extend(latLng);
    });


    document.querySelectorAll('.locations-flex .accordion > div > button.accordion-button').forEach(function (el, key) {
      el.addEventListener('click', function (e) {
        gmarkers.forEach(function (marker) {
          var markerCoords = marker.getPosition().lat() + ',' + marker.getPosition().lng();
          if (el.parentNode.getAttribute('data-coords') == markerCoords && !checkWidth(768) && el.classList.contains('open')) {
            new google.maps.event.trigger(marker, 'click');
          }
        });

        if (!checkWidth(768)) {
          document.querySelector('.locations-flex .accordion').scrollTop = key * 70;
        }
      });
    });

    var locationAccord = document.querySelectorAll('.locations-flex .accordion')
    // console.log("LOCATIONS ACCORDION", locationAccord);

    if (searchParams.get('city') != null) {
      geocoder.geocode({'address': cityAddress}, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          // map.setCenter(results[0].geometry.location);
          var bounds = new google.maps.LatLngBounds(),
            pin = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location
            });

          for (var i = 0; i < gmarkers.length; i++) {
            var gmarkerCoords = new google.maps.LatLng(gmarkers[i].getPosition().lat(), gmarkers[i].getPosition().lng()),
              markerDistance = google.maps.geometry.spherical.computeDistanceBetween(pin.getPosition(), gmarkerCoords);

            gmarkers[i]['markerDistance'] = markerDistance;
          }

			gmarkers.sort((a, b) => a.markerDistance - b.markerDistance);

			const accordion = document.querySelector('.locations-flex .accordion');
			const regionHeadings = Array.from(accordion.querySelectorAll(':scope > h4[data-region]'));
			const clinicElements = Array.from(accordion.querySelectorAll(':scope > div[data-region]'));

			const visibleMarkers = gmarkers
			  .filter((marker) => marker.markerDistance < radius)
			  .slice(0, 5);

			const visibleCoordinates = new Set(
			  visibleMarkers.map((marker) => marker.getPosition().lat() + ',' + marker.getPosition().lng())
			);

			const distanceByCoordinates = new Map(
			  gmarkers.map((marker) => [
			    marker.getPosition().lat() + ',' + marker.getPosition().lng(),
			    marker.markerDistance
			  ])
			);

			gmarkers.forEach((marker) => {
			  const coords = marker.getPosition().lat() + ',' + marker.getPosition().lng();
			  marker.setVisible(visibleCoordinates.has(coords));
			});

			const groupedClinics = {};

			regionHeadings.forEach((heading) => {
			  const region = heading.getAttribute('data-region');
			
			  groupedClinics[region] = clinicElements
			    .filter((clinic) => clinic.getAttribute('data-region') === region)
			    .sort((a, b) => {
			      return (distanceByCoordinates.get(a.getAttribute('data-coords')) ?? Infinity) -
			             (distanceByCoordinates.get(b.getAttribute('data-coords')) ?? Infinity);
			    });
			});

			clinicElements.forEach((clinic) => {
			  clinic.classList.toggle('hide', !visibleCoordinates.has(clinic.getAttribute('data-coords')));
			  clinic.style.order = '';
			});

			regionHeadings.forEach((heading) => {
			  const region = heading.getAttribute('data-region');
			  const clinics = groupedClinics[region];
			  const visibleClinics = clinics.filter((clinic) => !clinic.classList.contains('hide'));
			
			  heading.style.order = '';
			  heading.style.display = visibleClinics.length > 0 ? 'block' : 'none';
			
			  accordion.appendChild(heading);
			
			  clinics.forEach((clinic) => {
			    accordion.appendChild(clinic);
			  });
			});

			const updatedBounds = new google.maps.LatLngBounds();

			visibleMarkers.forEach((marker) => {
			  updatedBounds.extend(marker.getPosition());
			});

			if (!updatedBounds.isEmpty()) {
			  map.fitBounds(updatedBounds);
			}

        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    }

    map.fitBounds(bounds);
  }

  var useLocation = document.querySelector('.use-location');

  if (useLocation) {
  	useLocation.addEventListener('click', () => {
  		let url = new URL(window.location.href);
  		var searchParams = url.searchParams;  
  		if (navigator.geolocation) {
  			navigator.geolocation.getCurrentPosition(
  				(position) => {
  					document.querySelector('.city-input').value = 'Current Location';
  					searchParams.delete('pos');
  					searchParams.append('pos', position.coords.latitude + ',' + position.coords.longitude);
  					window.history.replaceState(null, null, url);
  				},
  				(error) => {
  					alert('Error while getting current location: ' + error.message);
  				}
  			);
  		} else {
  			alert('Browser doesn\'t support Geolocation');
  		}
  	});
  }

  var findByLocation = document.querySelector('.find-by-location');
  
  if (findByLocation) {
  	findByLocation.addEventListener('click', () => {
  		document.querySelector('.button.locations.tab-button').click();
  	});
  }

  document.querySelectorAll('.clear-search').forEach(function (clearSearch) {
    clearSearch.addEventListener('click', function (e) {
      let url = new URL(window.location.href);
      var searchParams = url.searchParams;

      ['physicians', 'locations', 'city', 'pos'].forEach((el) => {
        searchParams.delete(el);
      });

      document.querySelector('.physicians-select').value = 0;
      document.querySelector('.regions-select').value = 0;
      document.querySelector('.locations-select').value = 0;
      document.querySelector('.city-input').value = '';

      window.history.replaceState(null, null, url);

      e.target.style.opacity = '0';

      e.target.previousSibling.click();
    });
  });

//   if (document.querySelector('.tab-button.physicians').classList.contains('active')) {
//     formPhysicians.querySelector('button[type=submit]').click();
//   } else if (document.querySelector('.tab-button.locations').classList.contains('active')) {
//     formLocations.querySelector('button[type=submit]').click();
//   }
}

/*=============================
=      Load 3rd Party JS      =
=============================*/

// window.addEventListener('load', function() {
// 	var js = [
// 		''
// 	];

// 	js.forEach(function(src) {
// 		addJS(src);
// 	});
// });

